import { Box, Typography, Hidden } from '@mui/material';
import { AppLink } from 'components/core/AppLink/AppLink';
import Grid from 'components/core/Grid';
import { CheckoutSectionTitle } from 'components/views/pages/Checkout/components/CheckoutSectionTitle';
import { androidStoreBadge, appleStoreBadge, qrAppStoreBadge } from 'config/imageUrls';
import { androidAppUrl, iosAppUrl } from 'config/urls';
import styled from 'styled-components';

const StyledMobileAppBox = styled(Box)`
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: ${props => props.theme.spacing(2)};
  display: flex;
  align-items: center;
  background-color: #fff;

  & img {
    margin-left: ${props => props.theme.spacing(2)};
  }
`;

export const CheckoutDownloadMobileApp = () => {
  return (
    <Grid item xs={12}>
      <StyledMobileAppBox>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <CheckoutSectionTitle mb={0}>Download the Mobile App</CheckoutSectionTitle>
          </Grid>
          <Grid item xs={12} md={7} lg={8}>
            <Typography variant="body1">
              For the best experience, make sure to download the mobile app for easy reservation management, access
              information and communication with the property host.
            </Typography>
            <Box mt={3}>
              <AppLink href={androidAppUrl} openInNewTab>
                <img src={androidStoreBadge} height={56} />
              </AppLink>
              <AppLink href={iosAppUrl} openInNewTab>
                <img src={appleStoreBadge} height={56} />
              </AppLink>
            </Box>
          </Grid>
          <Hidden mdDown>
            <Grid item xs={12} md={5} lg={4}>
              <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-evenly' }}>
                <img src={qrAppStoreBadge} height={160} />
              </Box>
            </Grid>
          </Hidden>
        </Grid>
      </StyledMobileAppBox>
    </Grid>
  );
};

